import * as React from "react";
import { InputNumber } from "primereact/inputnumber";
import { RateReliefCalculatorServiceResponse } from "../../../services/api";

export default function MinMaxCompRates({ rates }: { rates?: RateReliefCalculatorServiceResponse }) {
  return (
    <div className="flex flex-col gap-4 p-6 border rounded border-allstate-blue">
      <h3 className="text-lg font-medium">Maximum relief</h3>

      <div className="grid grid-cols-1 gap-4">
        <div className="flex flex-col gap-2">
          <label htmlFor="maxRelief_noComp">No comp</label>
          <InputNumber disabled value={(rates?.maxReliefNoComp || 0) * 100} suffix="%" inputId="maxRelief_noComp" />
        </div>
        <div className="flex flex-col gap-2">
          <label htmlFor="maxRelief_withFullyInsuredComp">With fully insured comp</label>
          <InputNumber disabled value={(rates?.maxReliefWFIComp || 0) * 100} suffix="%" inputId="maxRelief_withFullyInsuredComp" />
        </div>
        <div className="flex flex-col gap-2"> 
          <label htmlFor="maxRelief_withSelfFundedComp">With self funded comp</label>
          <InputNumber disabled value={(rates?.maxReliefWSFComp || 0) * 100} suffix="%" inputId="maxRelief_withSelfFundedComp" />
        </div>
      </div>
    </div>
  )
}